import {
  cancelFlushSession,
  finalizeFlushSession,
  flushBin,
  getActiveFlushSession,
  getFlushSession,
  listFlushMerchants,
  listSuggestedFlushes,
  markFlushLineLost,
  scanFlushItem,
  startFlushSession,
} from "./schema/flush";

export const groupM: {
  cancelFlushSession: typeof cancelFlushSession;
  finalizeFlushSession: typeof finalizeFlushSession;
  flushBin: typeof flushBin;
  getActiveFlushSession: typeof getActiveFlushSession;
  getFlushSession: typeof getFlushSession;
  listFlushMerchants: typeof listFlushMerchants;
  listSuggestedFlushes: typeof listSuggestedFlushes;
  markFlushLineLost: typeof markFlushLineLost;
  scanFlushItem: typeof scanFlushItem;
  startFlushSession: typeof startFlushSession;
} = {
  cancelFlushSession,
  finalizeFlushSession,
  flushBin,
  getActiveFlushSession,
  getFlushSession,
  listFlushMerchants,
  listSuggestedFlushes,
  markFlushLineLost,
  scanFlushItem,
  startFlushSession,
};
